import React from 'react';
import PropTypes from 'prop-types';
import BaseTextArea from 'react-autosize-textarea';

import classNames from 'classnames';

import './style.css';

const TextArea = ({ label, id, className, looks, icon: Icon, ...rest }) => {
  const customClassName = classNames(
    'text-area-container',
    className,
    `-${looks}`,
    {
      '-with-icon': Icon,
    }
  );
  return (
    <div className={customClassName}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <div className="text-area-control">
        <BaseTextArea id={id} {...rest} />
        {Icon ? <Icon className="text-area-control-icon" /> : null}
      </div>
    </div>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.func,
  looks: PropTypes.oneOf(['normal', 'input', 'transparent', 'white']),
};

TextArea.defaultProps = {
  label: null,
  id: null,
  className: null,
  icon: null,
  looks: 'normal',
};

export default TextArea;
